﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthController = void 0;
const net = require("@ivanlog/net");
const idb_1 = require("idb");
const gs = require("@ivanlog/gs");
const AppControllerBase_1 = require("./AppControllerBase");
const gs_1 = require("@ivanlog/gs");
const StateLogin_1 = require("../states/StateLogin");
const AuthSession_1 = require("./classes/AuthSession");
const AccessTypeEnum_1 = require("../enums/AccessTypeEnum");
class AuthController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._onLoginToken = new gs.EventToken();
        this.onLogin = new gs.EventGS(this._onLoginToken);
        this._onLogoutToken = new gs.EventToken();
        this.onLogout = new gs.EventGS(this._onLogoutToken);
        this._onRefrehUserToken = new gs.EventToken();
        this.onRefrehUserToken = new gs.EventGS(this._onRefrehUserToken);
        this.app.api.admin.getHTTPClient().addInvalidResponceCodeHandler(net.HTTPCodes.Unauthorized, () => __awaiter(this, void 0, void 0, function* () { yield this.dropAuthState(); return true; }));
        this.app.api.driver.getHTTPClient().addInvalidResponceCodeHandler(net.HTTPCodes.Unauthorized, () => __awaiter(this, void 0, void 0, function* () { yield this.dropAuthState(); return true; }));
        this.app.api.customer.getHTTPClient().addInvalidResponceCodeHandler(net.HTTPCodes.Unauthorized, () => __awaiter(this, void 0, void 0, function* () { yield this.dropAuthState(); return true; }));
        this.onLogin.addHandler((session) => __awaiter(this, void 0, void 0, function* () {
            this._session = session;
            this.app.api.setSid(this._session.sid);
        }));
        this.onLogout.addHandler(() => __awaiter(this, void 0, void 0, function* () {
            this.app.api.setSid(null);
        }));
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.openDb();
            yield this.loadAuthState();
        });
    }
    userHasAccess(user, access) {
        for (const a of user.accesses)
            if (a.type === AccessTypeEnum_1.AccessTypeEnum[access]) {
                if (a.untilTime.getFullYear() < 2020)
                    return true;
                if (a.untilTime > new Date())
                    return true;
            }
        return false;
    }
    hasAccess(access) {
        if (!this.isAuth)
            return false;
        return this.userHasAccess(this.session.user, access);
    }
    get isAuth() { if (this._session)
        return true;
    else
        return false; }
    get session() { return this._session; }
    /**
     * Проверяет соостояние авторизации пользователя и получает данные о текущем пользователе по сессии
     * @returns {boolean}
     */
    login(user, sid) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAuth)
                return;
            const session = new AuthSession_1.AuthSession();
            session.sid = sid;
            session.user = user;
            this._session = session;
            yield this.saveAuthState();
            this._onLoginToken.invoke(this._session);
            this._onRefrehUserToken.invoke(this._session.user);
            return true;
        });
    }
    logout(dropSessionOnServer = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isAuth) {
                yield gs_1.StateGS.Run(StateLogin_1.StateLogin);
                return;
            }
            if (dropSessionOnServer) {
                const result = yield this.app.api.admin.auth.logout();
                if (!result)
                    return;
            }
            yield this.dropAuthState();
        });
    }
    refreshUser() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isAuth)
                return;
            var user = yield this.app.api.admin.profiles.getUser(this._session.user.id);
            if (!user) {
                this.dropAuthState();
                return;
            }
            this._session.user = user;
            this.saveAuthState();
            this._onRefrehUserToken.invoke(this._session.user);
        });
    }
    dropAuthState() {
        return __awaiter(this, void 0, void 0, function* () {
            this._session = undefined;
            this.app.api.setSid(null);
            yield this.saveAuthState();
            yield this._onLogoutToken.invoke();
        });
    }
    openDb() {
        return __awaiter(this, void 0, void 0, function* () {
            this._db = yield (0, idb_1.openDB)("astraCabAuthDb", 1, {
                upgrade(db, oldVersion) {
                    switch (oldVersion) {
                        case 0:
                            db.createObjectStore("session", { keyPath: "sid" });
                            break;
                    }
                }
            });
        });
    }
    saveAuthState() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._db.clear('session');
            if (this._session)
                yield this._db.put("session", this._session);
        });
    }
    loadAuthState() {
        return __awaiter(this, void 0, void 0, function* () {
            this._session = undefined;
            const sessions = yield this._db.getAll("session");
            if (sessions.length > 0) {
                this._session = sessions[0];
                this.app.api.setSid(this._session.sid);
                this._onRefrehUserToken.invoke();
                //this._onLoginToken.invoke(this._session);            
            }
        });
    }
}
exports.AuthController = AuthController;
//# sourceMappingURL=AuthController.js.map